// Query keys shared by the check-in panel, the consent prompt and the month view.
export const MY_TODAY_KEY = ["me:attendance", "today"];
export const MY_ATTENDANCE_SETTINGS_KEY = ["me:attendance", "settings"];
export const ATTENDANCE_SUMMARY_KEY = "me:attendance-summary";

// Validation status of one check-in period (session).
// REJECTED time is not counted in hours, so it is shown struck through.
export const SESSION_STATUS = {
  VALID: { label: "Valid", tone: "green" },
  FOR_REVIEW: {
    label: "For review",
    tone: "amber",
    icon: "bi-hourglass-split",
  },
  APPROVED: { label: "Approved", tone: "green", icon: "bi-check-circle" },
  REJECTED: { label: "Rejected", tone: "red", icon: "bi-x-circle" },
};

export const SOURCE_LABELS = {
  WEB: "Web",
  MOBILE: "Mobile app",
  MANUAL: "Added by HR",
  BIOMETRIC: "Biometrics",
};
